import { render, staticRenderFns } from "./RegionsMaintenanceComponent.vue?vue&type=template&id=7712b084&scoped=true"
import script from "./RegionsMaintenanceComponent.vue?vue&type=script&lang=js"
export * from "./RegionsMaintenanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7712b084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7712b084')) {
      api.createRecord('7712b084', component.options)
    } else {
      api.reload('7712b084', component.options)
    }
    module.hot.accept("./RegionsMaintenanceComponent.vue?vue&type=template&id=7712b084&scoped=true", function () {
      api.rerender('7712b084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1/RegionsMaintenanceComponent.vue"
export default component.exports